<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('segments') }} -> {{ $t('create-segment') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('filter') }}
        </h1>
        <div class="form-row">
          <div class="form-group">
            <label>{{ $t('search') }}</label>
            <input class="large" type="text" :placeholder="$t('search')" v-model="search"
                   v-on:keyup.enter="getClients()">
          </div>
          <div class="form-group">
            <label>
              {{ $t('segments') }}
            </label>
            <div class="select__wrapper">
              <select class="custom-select" v-model="selectedSegment" @change="getClients">
                <option value="">{{ $t('all') }} {{ $t('clients').toString().toLocaleLowerCase() }}</option>
                <option v-for="item in segments" v-bind:key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-dynamic" :class="dynamicOpen ? 'open': ''" v-if="dynamicFields.length > 0" @keyup.enter="getClients">
          <div class="top-dynamic" @click="openDynamicFilter">
            <div class="d-flex align-items-center">
              <div class="dynamic-arrow"></div>
              <div class="dynamic-title">Фильтры</div>
            </div>
            <div class="buttons">
              <a class="btn btn-secondary refresh" @click="refreshDynamic">Сбросить</a>
              <a class="btn btn-primary accept" @click="getClients">Применить</a>
            </div>
          </div>
          <div class="dynamic-body">
            <span>Нужно нажать на фильтр для его заполнения.</span>
            <div class="selected-dynamic-filter" v-for="field in dynamicFields" :key="field.id">
              <div class="form-group">
                <label @click="openField(field.name_key)">{{ field.name }}</label>
                <div class="input-group" v-if="field.type_field == 0" v-show="fieldOpen[field.name_key]">
                  <input class="small" type="text" placeholder="Поиск" @input="dynamicVarChar(field.name_key, $event.target.value)" v-model="dynamicSearch.searchVarChar[field.name_key]"/>
                </div>
                <div class="input-group" v-if="field.type_field == 1" v-show="fieldOpen[field.name_key]">
                  <select @input="dynamicDouble('condition-' + field.name_key, $event.target.value)" placeholder="Условие" v-model="dynamicSearch.searchDouble['condition-' + field.name_key]">
                    <option value="">Выберите условие</option>
                    <option value="1">Больше</option>
                    <option value="2">Меньше</option>
                    <option value="3">Больше или равно</option>
                    <option value="4">Меньше или равно</option>
                    <option value="5">Не равно</option>
                    <option value="6">Равно</option>
                  </select>
                  <input type="text" @input="dynamicDouble(field.name_key, $event.target.value)" placeholder="До" v-model="dynamicSearch.searchDouble[field.name_key]"/>
                </div>
                <div class="input-group" v-if="field.type_field == 2" v-show="fieldOpen[field.name_key]">
                  <input type="date" placeholder="От" @input="dynamicDate('after-' + field.name_key, $event.target.value)" v-model="dynamicSearch.searchDate['after-' + field.name_key]"/>
                  <input type="date" placeholder="До" @input="dynamicDate('before-' + field.name_key, $event.target.value)" v-model="dynamicSearch.searchDate['before-' + field.name_key]"/>
                </div>
              </div>
              <div class="group-selected" v-if="dynamicSearch.searchVarChar[field.name_key]">
                <a @click="dynamicVarChar(field.name_key, '')">{{ dynamicSearch.searchVarChar[field.name_key] }}</a>
              </div>
              <div class="group-selected" v-if="dynamicSearch.searchDouble['condition-' + field.name_key] || dynamicSearch.searchDouble[field.name_key]">
                <a @click="dynamicDouble('condition-' + field.name_key, '')" v-if="dynamicSearch.searchDouble['condition-' + field.name_key]">{{ getConditionFromInt(dynamicSearch.searchDouble['condition-' + field.name_key]) }}</a>
                <a style="margin-left: 10px;" @click="dynamicDouble(field.name_key, '')" v-if="dynamicSearch.searchDouble[field.name_key]">{{ dynamicSearch.searchDouble[field.name_key] }}</a>
              </div>
              <div class="group-selected" v-if="dynamicSearch.searchDate['after-' + field.name_key] || dynamicSearch.searchDate['before-' + field.name_key]">
                <a @click="dynamicDate('after-' + field.name_key, '')" v-if="dynamicSearch.searchDate['after-' + field.name_key]">{{ dynamicSearch.searchDate['after-' + field.name_key] }} </a>
                <a @click="dynamicDate('before-' + field.name_key, '')" style="margin-left: 10px;" v-if="dynamicSearch.searchDate['before-' + field.name_key]">{{ dynamicSearch.searchDate['before-' + field.name_key] }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-body">
        <div class="title-and-button">
          <h1 class="group__title">
            {{ $t('clients') }} ({{ cClient }})
          </h1>
        </div>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">
                №
              </th>
              <th scope="col">
                <label class="table__selected">
                  <input type="checkbox" @change="selectAllClient" v-model="selectAll">
                  <span class="checkmark"></span>
                </label>
              </th>
              <th scope="col">{{ $t('FIO') }}</th>
              <th scope="col">{{ $t('phone') }} ({{ cClientPhone }})</th>
              <th scope="col">E-mail ({{ cClientEmail }})</th>
              <th scope="col">{{ $t('segment-participant') }}</th>
              <th scope="col">
                <img src="@/assets/social/telegram.svg">
              </th>
              <th scope="col">
                <img src="@/assets/social/viber.svg">
              </th>
              <th scope="col">
                <img src="@/assets/social/email.svg">
              </th>
              <th scope="col">
                <img src="@/assets/social/sms.svg">
              </th>
            </tr>
            </thead>
            <tbody v-if="clients.length > 0">
            <tr v-for="(item, index) in clients" v-bind:key="item.id">
              <th scope="row">
                {{ index + 1 }}
              </th>
              <th scope="row">
                <label class="table__selected">
                  <input type="checkbox" v-model="selectedClient" :value="item.id">
                  <span class="checkmark"></span>
                </label>
              </th>
              <td class="pointer" v-on:click.self="showClientModal(item.id)">{{
                  (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '')
                }}
              </td>
              <td v-if="item.phone"><img src="@/assets/icon/check.svg"></td>
              <td v-else><img src="@/assets/icon/cross.svg"></td>
              <td v-if="item.email"><img src="@/assets/icon/check.svg"></td>
              <td v-else><img src="@/assets/icon/cross.svg"></td>
              <td>{{ item.segmentCount }}</td>
              <td>{{ item.telegramCount }}</td>
              <td>{{ item.viberCount }}</td>
              <td>{{ item.emailCount }}</td>
              <td>{{ item.smsCount }}</td>
            </tr>
            </tbody>
            <div class="tbody-empty" v-else>
              <p>Ничего не найдено</p>
            </div>
          </table>
        </div>
        <div class="form-row justify-content-center"
             v-if="clients.length < cClient && search === null || search === ''">
          <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
        </div>
        <div class="form-row mb-2">
          <a class="btn btn-primary" @click="showSegmentModal">{{ $t('create-segment') }}</a>
        </div>
        <p class="light-help">{{ $t('create-segment-about') }}</p>
        <p class="light-help">{{ $t('watch') }}
          <router-link class="link" to="/list-segment">{{ $t('list').toLocaleLowerCase() }}</router-link>
          {{ $t('previously-created-segments') }}
        </p>
      </div>
    </div>
    <createSegmentModal :client="selectedClient" v-show="isModalSegmentVisible"
                        @close="closeSegmentModal"/>
    <clientModal :id="selectUser" v-show="isModalClientVisible"
                 @close="closeClientModal"/>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import createSegmentModal from '../components/modal/createSegmentModal'
import clientModal from "../components/modal/clientModal";
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'create-segment',
  data: function () {
    return {
      clients: [],
      dynamicFields: [],
      fieldOpen: [],
      dynamicOpen: false,
      cClient: 0,
      cClientEmail: 0,
      cClientPhone: 0,
      page: 1,
      segments: [],
      selectedSegment: '',
      selectedClient: [],
      errors: [],
      isModalSegmentVisible: false,
      isModalClientVisible: false,
      selectUser: 0,
      selectAll: false,
      isLoading: false,
      fullPage: true,
      search: null,
      dynamicSearch: {
        searchVarChar: {},
        searchDouble: {},
        searchDate: {},
      },
    }
  },
  created: function () {
    this.getSegments();
    this.getClients();
  },
  mounted() {
    this.$root.$on('updateSegments', () => {
      this.getSegments();
    });
    this.$root.$on('updateClients', () => {
      this.getClients();
    });
  },
  methods: {
    getConditionFromInt: function(value){
      let result = '';
      if(value == 1){
        result = 'Больше'
      }else if(value == 2){
        result = 'Меньше'
      }else if(value == 3){
        result = 'Больше или равно'
      }else if(value == 4){
        result = 'Меньше или равно'
      }else if(value == 5){
        result = 'Не равно'
      }else if(value == 6){
        result = 'Равно'
      }
      return result;
    },
    openField: function(name){
      if(this.fieldOpen[name]){
        this.$set(this.fieldOpen, name, !this.fieldOpen[name]);
      }else{
        this.$set(this.fieldOpen, name, true);
      }
    },
    refreshDynamic: function(){
      this.dynamicSearch.searchVarChar = {};
      this.dynamicSearch.searchDouble = {};
      this.dynamicSearch.searchDate = {};
      this.getClients();
    },
    openDynamicFilter: function(){
      this.dynamicOpen = !this.dynamicOpen;
    },
    dynamicVarChar: function(index, value){
      if(!value){
        this.$delete(this.dynamicSearch.searchVarChar, index);
      }else{
        this.$set(this.dynamicSearch.searchVarChar, index, value);
      }
    },
    dynamicDouble: function(index, value){
      if(!value){
        this.$delete(this.dynamicSearch.searchDouble, index);
      }else{
        this.$set(this.dynamicSearch.searchDouble, index, value);
      }
    },
    dynamicDate: function(index, value){
      if(!value){
        this.$delete(this.dynamicSearch.searchDate, index);
      }else{
        this.$set(this.dynamicSearch.searchDate, index, value);
      }
    },
    nextPage: function () {
      this.page++;
      this.getClients();
    },
    selectAllClient: function () {
      let selectedClient = [];
      if (this.selectAll) {
        this.clients.map(function (value) {
          selectedClient.push(value.id)
        });
      }
      this.selectedClient = selectedClient;
    },
    getSegments: function () {
      this.isLoading = true;
      axios.post('getSegments').then(response => {
        var status = response.data.status;
        if (status) {
          this.segments = response.data.segments;
          this.selectedClient = [];
          this.selectAll = false;
          this.isLoading = false;
        }
      });
    },
    getClients: function () {
      this.isLoading = true;
      var data = {
        segment_id: this.selectedSegment,
        search: this.search,
        dynamicSearch: this.dynamicSearch,
        page: this.page
      }
      axios.post('getClients', data).then(response => {
        var status = response.data.status;
        if (status) {
          this.clients = response.data.clients;
          this.cClient = response.data.cClient;
          this.cClientEmail = response.data.cClientEmail;
          this.cClientPhone = response.data.cClientPhone;
          this.dynamicFields = response.data.dynamicFields;
          this.isLoading = false;
        }
      });
    },
    deleteClient: function (id) {
      this.isLoading = true;
      var data = {
        user_id: this.$store.getters.user,
        client_id: id
      }
      axios.post('deleteClient', data).then(response => {
        var status = response.data.status;
        if (status) {
          this.getClients();
          this.isLoading = false;
          this.$toast.success("Клиент успешно удален");
        }
      });
    },
    showSegmentModal() {
      if (this.selectedClient.length > 0) {
        this.isModalSegmentVisible = true;
      } else {
        this.$toast.error('Необходимо выбрать минимум 1 клиента');
      }
    },
    closeSegmentModal() {
      this.isModalSegmentVisible = false;
    },
    showClientModal(id) {
      this.selectUser = id;
      this.isModalClientVisible = true;
    },
    closeClientModal() {
      this.isModalClientVisible = false;
    }
  },
  components: {
    createSegmentModal, clientModal, loading
  }
}
</script>



